import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "infrastructure",
  "use": "infrastructure-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"infrastructure\"><path d=\"M9 2h6v6H9zM5 13v1H3v-3h8v-1h2v1h8v3h-2v-1zM1 16h6v6H1zM9 16h6v6H9zM17 16h6v6h-6z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol